import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import ParcoursFormFields from "./ParcoursFormFields";
import { useCreateParcours } from "../../../hooks/useCreateParcours";
import type { ParcoursDto } from "../../../api/parcoursApi";
import { useAuth } from "../../../auth/useAuth";

const INITIAL: ParcoursDto = {
  title: "",
  description: "",
  longDescription: "",
  contentMode: "PROGRAMME",
  paid: false,
  dates: [],
  lieuIds: [],
  artistIds: [],
  practicalInfos: [],
  resources: [],
  sponsors: [],
  programmes: [],
};

export default function ParcoursCreatePage() {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [draft, setDraft] = useState<ParcoursDto>(INITIAL);
  const create = useCreateParcours();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(draft, {
      onSuccess: (res) => navigate(`/admin/parcours/${res.id}`),
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title="Nouveau parcours"
        description={
          isAdmin
            ? "Création d'un nouveau parcours."
            : "Création d'un nouveau parcours — publié en gratuit par défaut. Un administrateur peut ensuite le passer en payant."
        }
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate("/admin/parcours")}>
              Annuler
            </Button>
            <Button type="submit" variant="primary" loading={create.isPending}>
              Créer
            </Button>
          </>
        }
      />
      <div className="bo-card">
        <ParcoursFormFields value={draft} onChange={setDraft} canEditPaid={isAdmin} />
      </div>
      {create.isError && <p className="bo-error-text">Erreur lors de la création : {(create.error as Error)?.message}</p>}
    </form>
  );
}
